// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import VoterIdDetailsActionType from './voter-id-details.types';

const INITIAL_STATE = {
	// Update Voter ID
	updateVoterIdResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** UPDATE VOTER ID START ************************/
		case VoterIdDetailsActionType.UPDATE_VOTER_ID_SUCCESS:
			return { ...state, updateVoterIdResponse: action.payload };

		case VoterIdDetailsActionType.UPDATE_VOTER_ID_FAILURE:
			return { ...state, updateVoterIdResponse: action.payload };

		case VoterIdDetailsActionType.UPDATE_VOTER_ID_RESPONSE_CHANGED:
			return { ...state, updateVoterIdResponse: null };

		/** ***************** UPDATE VOTER ID END ************************/

		default:
			return state;
	}
};
